import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteOrigin, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/core';
import { NavigationEnd, Router } from '@angular/router';
import { delay } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { RootSearchStore } from '../../../store';
import { ClickCursorDirective } from '../../directives/click-cursor.directive';
import { I18nPipe } from '../../i18n/i18n.pipe';
import { RtlDirective } from '../../i18n/rtl.directive';
import { HighlightPipe } from '../../pipes/highlight.pipe';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { DotsLoaderComponent } from '../dots-loader/dots-loader.component';

@Component({
  selector: 'gnx-analysis-search-bar',
  templateUrl: './analysis-search-bar.component.html',
  styleUrls: ['./analysis-search-bar.component.scss'],
  imports: [
    MatAutocompleteOrigin,
    RtlDirective,
    ClickCursorDirective,
    DotsLoaderComponent,
    MatAutocompleteTrigger,
    ReactiveFormsModule,
    MatAutocomplete,
    MatOption,
    DatePipe,
    I18nPipe,
    SafeHtmlPipe,
    HighlightPipe,
  ],
})
export class AnalysisSearchBarComponent implements OnInit, AfterViewInit {
  private fb = inject(FormBuilder);
  private router = inject(Router);

  protected searchStore = inject(RootSearchStore);

  private destroyRef = inject(DestroyRef);
  searchControl: FormControl;
  private enterDisabled: boolean;

  ngOnInit() {
    this.searchControl = this.fb.control('');
    this.searchControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef), debounceTime(500)).subscribe((value) => {
      this.searchStore.searchAnalyses({ payload: value });
    });

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
        delay(0),
      )
      .subscribe(() => {
        this.enterDisabled = false;
      });
  }

  ngAfterViewInit() {}

  onSelect(analysisId: number) {
    this.enterDisabled = true;
    this.router.navigate([`/analysis-tool/analysis/workbench/${analysisId}`]);
  }

  onSearch() {
    if (this.enterDisabled) {
      return;
    }
    if (this.searchControl.value) {
      this.router.navigate(['/analysis-tool/analyses'], { queryParams: { search: this.searchControl.value } });
    } else {
      this.onEscape();
    }
  }

  onEscape() {
    this.searchControl.setValue('', { emitEvent: false });
  }
}
